import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import tabbable from 'tabbable';
import { keyCodes } from '../../services';
import { EuiTitle } from '../title';
import { EuiNavDrawerGroup } from './nav_drawer_group';
import { EuiListGroup } from '../list_group/list_group';
import { EuiFocusTrap } from '../focus_trap';
export var EuiNavDrawerFlyout = function EuiNavDrawerFlyout(_ref) {
  var className = _ref.className,
      title = _ref.title,
      isCollapsed = _ref.isCollapsed,
      listItems = _ref.listItems,
      wrapText = _ref.wrapText,
      onClose = _ref.onClose,
      rest = _objectWithoutProperties(_ref, ["className", "title", "isCollapsed", "listItems", "wrapText", "onClose"]);

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      menuEl = _useState2[0],
      setMenuEl = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      tabbables = _useState4[0],
      setTabbables = _useState4[1];

  var LABEL = 'navDrawerFlyoutTitle';
  var classes = classNames('euiNavDrawerFlyout', {
    'euiNavDrawerFlyout-isCollapsed': isCollapsed,
    'euiNavDrawerFlyout-isExpanded': !isCollapsed
  }, className);

  var handleKeyDown = function handleKeyDown(e) {
    if (e.keyCode === keyCodes.ESCAPE) {
      handleClose();
    } else if (e.keyCode === keyCodes.TAB) {
      var tabs = tabbables;

      if (!tabs) {
        tabs = tabbable(menuEl).filter(function (el) {
          return el.tagName !== 'DIV';
        });
        setTabbables(tabs);
      }

      if (!e.shiftKey && document.activeElement === tabs[tabs.length - 1] || e.shiftKey && document.activeElement === tabs[0]) {
        handleClose();
      }
    }
  };

  var handleClose = function handleClose() {
    var shouldReturnFocus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    setTabbables(null);
    onClose(shouldReturnFocus);
  };

  return React.createElement("div", _extends({
    className: classes,
    "aria-labelledby": LABEL,
    onKeyDown: handleKeyDown,
    ref: setMenuEl
  }, rest), React.createElement(EuiTitle, {
    className: "euiNavDrawerFlyout__title",
    tabIndex: "-1",
    size: "xxs"
  }, React.createElement("div", {
    id: LABEL
  }, title)), listItems ? React.createElement(EuiFocusTrap, {
    returnFocus: false
  }, React.createElement(EuiNavDrawerGroup, {
    className: "euiNavDrawerFlyout__listGroup",
    ariaLabelledby: LABEL,
    listItems: listItems,
    wrapText: wrapText,
    onClose: function onClose() {
      return handleClose(false);
    }
  })) : null);
};
EuiNavDrawerFlyout.propTypes = {
  className: PropTypes.string,
  listItems: EuiListGroup.propTypes.listItems,
  wrapText: EuiListGroup.propTypes.wrapText,

  /**
   * Display a title atop the flyout
   */
  title: PropTypes.string,

  /**
   * Toggle the nav drawer between collapsed and expanded
   */
  isCollapsed: PropTypes.bool,

  /**
   * Passthrough function to be called when the flyout is closing
   * See ./nav_drawer.js
   */
  onClose: PropTypes.func
};
EuiNavDrawerFlyout.defaultProps = {
  isCollapsed: true
};
EuiNavDrawerFlyout.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "EuiNavDrawerFlyout",
  "props": {
    "isCollapsed": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Toggle the nav drawer between collapsed and expanded"
    },
    "className": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "listItems": {
      "type": {
        "name": "custom",
        "raw": "EuiListGroup.propTypes.listItems"
      },
      "required": false,
      "description": ""
    },
    "wrapText": {
      "type": {
        "name": "custom",
        "raw": "EuiListGroup.propTypes.wrapText"
      },
      "required": false,
      "description": ""
    },
    "title": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Display a title atop the flyout"
    },
    "onClose": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Passthrough function to be called when the flyout is closing\nSee ./nav_drawer.js"
    }
  }
};